import {
  ViewCertifications,
  ProjectPrevNext,
  ArticlePrevNext,
  LocationMarkers,
  ViewRecentContent,
  ViewRecentContentOverview,
  ViewRecentTaxonomyOverview,
  ViewRelevantContentBySubjects,
  ViewTopics,
  ViewTypes,
  ViewAllAnnualReports,
  ViewCampaignArticles,
  ViewRentalLocationsOverview,
  ViewRentalLocationsRelated,
} from '../implementations';


const mappers = {
  views_block__certfications_block_1: ViewCertifications,
  views_block__locations_block_1: LocationMarkers,
  views_block__content_recent_news: ViewRecentContent,
  views_block__content_recent_stories: ViewRecentContent,
  views_block__content_recent_activities: ViewRecentContent,
  views_block__content_recent_projects: ViewRecentContent,
  views_block__content_recent_vacancies: ViewRecentContent,
  views_block__content_recent_block_1: ViewRecentContent,
  views_block__previous_next_project_prev: ProjectPrevNext,
  views_block__previous_next_project_next: ProjectPrevNext,
  views_block__content_overview_block_2: ViewRecentContentOverview,
  views_block__content_overview_activities: ViewRecentContentOverview,
  views_block__content_overview_block_4: ViewRecentContentOverview,
  views_block__content_overview_block_5: ViewRecentContentOverview,
  views_block__content_overview_block_6: ViewRecentContentOverview,
  views_block__content_overview_block_7: ViewRecentContentOverview,
  views_block__content_overview_block_8: ViewRecentContentOverview,
  views_block__content_overview_block_9: ViewRecentContentOverview,
  views_block__content_overview_activities_pinned: ViewRecentContentOverview,
  views_block__taxonomy_overview_block_1: ViewRecentTaxonomyOverview,
  views_block__taxonomy_overview_block_2: ViewRecentTaxonomyOverview,
  views_block__campaign_articles_block_1: ViewCampaignArticles,
  views_block__relevant_content_by_subjects_block_1: ViewRelevantContentBySubjects,
  views_block__relevant_content_by_subjects_block_2: ViewRelevantContentBySubjects,
  views_block__previous_next_article_prev: ArticlePrevNext,
  views_block__previous_next_article_next: ArticlePrevNext,
  views_block__topics_block_1: ViewTopics,
  views_block__location_types_block_1: ViewTypes,
  views_block__annual_report_all: ViewAllAnnualReports,
  views_block__rental_locations_overview: ViewRentalLocationsOverview,
  views_block__rental_locations_related: ViewRentalLocationsRelated,
};

export default mappers;
